import { Component, OnDestroy, OnInit } from '@angular/core';
import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { APP_ROUTES } from '@app/app.routes';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Offers, PreviewOffer } from '../../../../core/models/offers.model';
import { ISkeleton } from '../../../../core/models/skeleton.model';
import { OffersService } from '../../../../domain/services/offers.service';
import { AppFacade } from '../../../../facades/app.facade';
import { OffersFacade } from '../../../../facades/offers.facade';
import { Title } from '@angular/platform-browser';
import { StorageService } from '@app/data/browser/storage.service';
import { ILargeContentConfig } from '@app/core/models/app.model';
import { TOOLTIP_CONTENT, TOOLTIP_DELAY } from '@app/presentation/mo-layout/tooltip.constant';
import { ETOOLTIP_POSITION } from '@app/core/enums/tooltip.enum';

@Component({
  selector: 'home-offers',
  templateUrl: './offers.page.html',
  styleUrls: ['./offers.page.scss'],
})
export class OffersPage implements OnInit, OnDestroy {
  public offerSelected: number = 12;
  public previewOfferSelected: PreviewOffer | {};
  public APP_ROUTES = APP_ROUTES;
  public CONST = CONST;
  public amount$: Observable<string>;
  public offers$: Observable<Offers[]>;
  public offers: Offers[];
  public previewOffers$: Subscription;
  public previewOffer$: Subscription;
  public isLoading$: Observable<boolean>;
  public previewOffers: PreviewOffer[];
  public skeletonConfig: ISkeleton;
  public summarySkeletonConfig: ISkeleton;
  public isLargeContent$: Observable<ILargeContentConfig>;
  public ETOOLTIP_POSITION = ETOOLTIP_POSITION;
  public TOOLTIP_CONTENT = TOOLTIP_CONTENT;
  public TOOLTIP_DELAY = TOOLTIP_DELAY;

  constructor(
    private _offersFacade: OffersFacade,
    private _appFacade: AppFacade,
    private _titleService: Title,
    private _offersService: OffersService,
    private _storageService: StorageService
  ) {
    this._titleService.setTitle('Plan de pagos');
  }

  ngOnInit(): void {
    this._setValues();
  }

  ngOnDestroy(): void {
    this.previewOffers$.unsubscribe();
    this.previewOffer$.unsubscribe();
  }

  private _setValues() {
    this._storageService.setItem('offerSelected', this.offerSelected);
    this._offersFacade.setNumberOfInstallments(this.offerSelected);
    this.amount$ = this._offersFacade.amount$;
    this.offers$ = this._offersFacade.offers$;
    this.isLoading$ = this._offersFacade.isLoading$;
    this.isLargeContent$ = this._appFacade.largeContentConfig$;
    this.skeletonConfig = {
      appearance: 'line',
      theme: {
        height: '325px',
      },
    };

    this.summarySkeletonConfig = {
      appearance: 'line',
      theme: {
        height: '200px',
      },
    };

    this.previewOffers$ = this._offersFacade.previewOffers$
      .pipe(filter((offer) => typeof offer !== 'undefined'))
      .subscribe((previewOffers) => (this.previewOffers = previewOffers));

    this.previewOffer$ = this._offersFacade.previewOffer$.subscribe((previewOffer) => {
      this.previewOfferSelected = previewOffer;
      this._storageService.setItem('previewOffer', this.previewOfferSelected);
    });
  }

  public handleOffer(type: number) {
    this.offerSelected = type;
    this._storageService.setItem('offerSelected', this.offerSelected);
    this._offersFacade.setNumberOfInstallments(this.offerSelected);
  }

  public handlePreviewOffer(previewOffer): PreviewOffer {
    this._storageService.setItem('previewOffer', previewOffer);
    return (this.previewOfferSelected = previewOffer);
  }

  public setPreviewOfferById(id: string): PreviewOffer {
    return this._offersService.setPreviewOfferById(this.previewOffers, id);
  }

  public onSelectOfferId(offerId: string) {
    this._offersFacade.setSelectedOfferId(offerId);
  }

  public onKillPurchase() {
    this._appFacade.killPurchase();
  }
}
